import { Component, Vue } from 'vue-property-decorator'
import { queryUsersList, queryUsersRole, setUsersRole, setCrmUserId, editEduRoleForPaperChage, queryOperatorMonitorList, changeWorkRoleForOperator, setOperatorStaffGroup } from '@/api'
@Component({ name: 'employee-role-page' })
export default class AllocationListPage extends Vue {
  private dataType = false // false 待分配 true 已分配
  private employeeName: any = null
  private totalPage = 1;
  private hightId: any = null
  private currentPage = 1;
  private filterData: any = {}
  private filterResult: any = null
  private filterTypeChoose = null;

  private tableData = []
  private tableloading: any = false
  private options = []
  private OperatorMonitorList = []

  created () {
    this.initPageData()
    this.queryUsersRolelist()
  }

  private async initPageData () {
    this.tableloading = true
    const param: any = { haveRole: this.dataType, page: this.currentPage, limit: 20, name: this.employeeName }
    const result: any = await queryUsersList(param)
    const { allPage, currentPage, userList } = result
    this.currentPage = currentPage
    this.totalPage = allPage
    this.tableData = userList
    this.tableData.forEach((item: any) => {
      this.$set(item, 'oldcrmUserId', item.crmUserId)
      this.$set(item, 'oldMonitorId', item.monitorId)
    })
    this.tableloading = false
  }

  private async queryUsersRolelist () {
    const result: any = await queryUsersRole({})
    this.options = result
    const resultlist: any = await queryOperatorMonitorList({})
    this.OperatorMonitorList = resultlist
  }

  /**
   * [description] 分页切换回调函数
   */
  private async onPageChange () {
    await this.initPageData()
  }

  private async onTypeChange (type: any) {
    if (!this.tableloading) {
      this.tableData = []
      this.dataType = type
      this.currentPage = 1
      await this.initPageData()
    }
  }

  private async changeCrmUserId (item: any) {
    const oldcrmUserId = item.oldcrmUserId
    const { data, error }: any = await setCrmUserId({ userId: item.id, crmUserId: item.crmUserId })
    if (error.returnCode === 0) {
      this.$message({ message: '设置成功', type: 'success' })
    } else {
      this.$set(item, 'crmUserId', item.oldcrmUserId)
    }
  }

  private rowClicked (row: any) {
    this.hightId = row.id
  }

  private async isCharge (row: any) {
    const { error }: any = await editEduRoleForPaperChage({ userId: row.id, isCharge: row.isCharge })
    if (!error) {
      this.$message({ message: '设置成功', type: 'success' })
    }
  }

  private async saveRole (item: any) {
    const { error }: any = await setUsersRole({ roleId: item.workRoleId, userId: item.id })
    if (!error) {
      this.$message({ message: '设置成功', type: 'success' })
      await this.initPageData()
    }
  }

  private async setRole (item: any) {
    const { error }: any = await changeWorkRoleForOperator({ userId: item.id, roleId: item.workRoleId })
    if (!error) {
      this.$message({ message: '设置成功', type: 'success' })
      await this.initPageData()
      await this.queryUsersRolelist()
    }
  }

  private async setMentor (item: any) {
    const { error }: any = await setOperatorStaffGroup({ operatorStaffId: item.id, operatorMonitorId: item.monitorId, operatorStaffIdold: item.oldMonitorId })
    if (!error) {
      this.$message({ message: '设置成功', type: 'success' })
      await this.initPageData()
      await this.queryUsersRolelist()
    }
  }
}
